import React from 'react';
import { PawPrint as LucidePawPrint } from 'lucide-react';

interface PawPrintProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const PawPrint: React.FC<PawPrintProps> = ({ width = 24, height = 24, className, style }) => (
  <LucidePawPrint width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default PawPrint;
